import React, { useEffect, useRef, useState } from 'react';
import { useAuthContext } from '../hooks/useAuthContext';
import { useNavigate } from "react-router-dom";

//import PaymentForm from '../components/PaymentForm';
import { PaymentClientInfo } from '../components/PaymentClientInfo';
import { PaymentSetup } from '../components/PaymentSetup';
import { PaymentStructure } from '../components/PaymentStructure';
import { PaymentStructure2 } from '../components/PaymentStructure2';
import { useMultistepForm } from '../hooks/useMultistepForm';

const Create = () => {
	const INITIAL_DATA = {
		title: '',
		startDate: '',
		lastValidDate: '',
		currency: '',
		exchangeRate: 1,
		price: 0,
		interestRate: 0,
		paymentType: '',
		monthlyPayment: 0,
		paymentPlan: [],
		cashInAdvance: 0,
		buyerName: '',
		buyerPhone: '',
		buyerMail: '',
		buyerAddress: '',
		islandNo: '',
		parselNo: '',
		blokNo: '',
	};

	const [data, setData] = useState(INITIAL_DATA);
	const { user } = useAuthContext();
	const navigate = useNavigate();

	function updateFields(fields) {
		setData((prev) => {
			return { ...prev, ...fields };
		});
	}

	// Asgari peşinat yüzdesini ayarlardan al
	const [minDownPaymentPercent, setMinDownPaymentPercent] = useState(0);
	useEffect(() => {
		fetch('/api/app-settings')
			.then((res) => res.json())
			.then((settings) => {
				if (typeof settings?.minDownPaymentPercent === 'number') {
					setMinDownPaymentPercent(settings.minDownPaymentPercent);
				}
			})
			.catch((error) => console.error('Error fetching app settings:', error));
	}, []);

	// Sunucu doğrulamasını geçmesi için yukarı yuvarlanır
	const minCashInAdvance = Math.ceil(
		((Number(data.price) || 0) * minDownPaymentPercent) / 100
	);

	// Peşinatı asgari tutarla doldur; kullanıcının girdiği tutarın üzerine yazma
	const autoCashInAdvance = useRef(null);
	useEffect(() => {
		const current = Number(data.cashInAdvance) || 0;
		if (current === 0 || current === autoCashInAdvance.current) {
			autoCashInAdvance.current = minCashInAdvance;
			updateFields({ cashInAdvance: minCashInAdvance });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [minCashInAdvance]);

	const {
		steps,
		currentStepIndex,
		step,
		isFirstStep,
		previous,
		next,
		isLastStep,
	} = useMultistepForm([
		<PaymentSetup {...data} updateFields={updateFields} />,
		data.paymentType === 'Sabit Plan' ? (
			<PaymentStructure
				{...data}
				minCashInAdvance={minCashInAdvance}
				updateFields={updateFields}
			/>
		) : (
			<PaymentStructure2
				{...data}
				minCashInAdvance={minCashInAdvance}
				updateFields={updateFields}
			/>
		),
		<PaymentClientInfo {...data} updateFields={updateFields} />,
	]);

	async function onSubmit(e) {
		e.preventDefault();

		if (isLastStep) {
			const payment = {
				title: data.title,
				startDate: data.startDate,
				lastValidDate: data.lastValidDate,
				monthlyPayment: data.monthlyPayment,
				currency: data.currency,
				price: data.price,
				interestRate: data.interestRate,
				exchangeRate: data.exchangeRate,
				paymentType: data.paymentType,
				paymentPlan: data.paymentPlan,
				cashInAdvance: data.cashInAdvance,
				buyerName: data.buyerName,
				buyerPhone: data.buyerPhone,
				buyerMail: data.buyerMail,
				buyerAddress: data.buyerAddress,
				islandNo: data.islandNo,
				parselNo: data.parselNo,
				blokNo: data.blokNo,
			};
			if (!user) {
				return;
			}
			console.log(payment);

			const response = await fetch('/api/payments', {
				method: 'POST',
				body: JSON.stringify(payment),
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user.token}`,
				},
			});
			const json = await response.json();

			if (response.ok) {
				INITIAL_DATA.title = '';
				INITIAL_DATA.startDate = '';
				INITIAL_DATA.lastValidDate = '';
				INITIAL_DATA.currency = '';
				INITIAL_DATA.price = 0;
				INITIAL_DATA.interestRate = 0;
				INITIAL_DATA.exchangeRate = 1;
				INITIAL_DATA.paymentType = '';
				INITIAL_DATA.monthlyPayment = 0;
				INITIAL_DATA.paymentPlan = [];
				INITIAL_DATA.cashInAdvance = 0;
				INITIAL_DATA.buyerName = '';
				INITIAL_DATA.buyerPhone = '';
				INITIAL_DATA.buyerMail = '';
				INITIAL_DATA.buyerAddress = '';
				INITIAL_DATA.islandNo = '';
				INITIAL_DATA.parselNo = '';
				INITIAL_DATA.blokNo = '';
				
				navigate('/');
			}
			else {
				alert(json?.error || 'Hatalı işlem. Lütfen girdiğiniz değerleri kontrol edin.');
			}
		} else {
			next();
		}
	}

	// Multi-step Form
	return (
		<div className="create-container">
			<form className="form-container" onSubmit={onSubmit}>
				<div className="create-step">
					{currentStepIndex + 1} / {steps.length}
				</div>
				{step}
				<div className="create-context">
					{!isFirstStep && (
						<button type="button" onClick={previous}>
							Geri
						</button>
					)}
					{isLastStep ? (
						<button>
							Bitir
						</button>
					) : (
						<button>İleri</button>
					)}
				</div>
			</form>
		</div>
	);
};

export default Create;
